import { makeStyles } from '@material-ui/core/styles'

export const answerInputStyles = makeStyles(() => ({
    outerContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignContent: 'space-between',
        margin: 10
    },
    answers: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        margin: '20px 0'
    }

}))

export const textInputStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '10px 4px',
    },

    cssLabel: {
        color: '#33949E',
    },

    cssOutlinedInput: {
        fontSize: '18px !important',
        '&$cssFocused $notchedOutline': {
            borderColor: 'white !important',
            color: 'white !important',
        }
    },

    cssFocused: {
        color: 'white !important',
    },

    notchedOutline: {
        borderWidth: '1px',
        color: 'white',
        borderColor: '#33949E !important',
    },

}))

export const titleInputStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: -40,
        marginLeft: 40,
        marginBottom: 40,
        width: '100%',
    },

    cssLabel: {
        color: '#33949E'
    },

    cssOutlinedInput: {
        fontSize: '18px !important',
        backgroundColor: 'black',
        borderRadius: 20,
        '&$cssFocused $notchedOutline': {
            borderColor: '#33949E !important',
            color: '#33949E !important',
        }
    },

    cssFocused: {
        color: '#33949E !important',
    },

    notchedOutline: {
        borderWidth: '1px',
        color: 'white',
        borderColor: '#33949E !important',
    },

}))

export const textBoxStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 20,
        marginBottom: 40,

    },

    cssLabel: {
        color: '#33949E'
    },

    cssOutlinedInput: {
        fontSize: '18px !important',
        backgroundColor: 'black',
        borderRadius: 20,
        '&$cssFocused $notchedOutline': {
            borderColor: '#33949E !important',
            color: '#33949E !important',
        }
    },

    cssFocused: {
        color: '#33949E !important',
    },

    notchedOutline: {
        borderWidth: '1px',
        color: 'white',
        borderColor: '#33949E !important',
    },

}))
